import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { ImagesService } from '../../images.service';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'app-image-upload',
    templateUrl: './image-upload.component.html',
    styleUrls: ['./image-upload.component.scss']
})
export class ImageUploadComponent implements OnInit {
    env = environment;

    @Input() type;
    @Input() ownerId;
    @Input() text = 'Click or drop files here to upload';
    @Output() imageUploaded: EventEmitter<any> = new EventEmitter<any>();
    user: any;
    uploadConfig: any;
    resizeWidth: 1000;

    constructor(
        private imagesService: ImagesService
    ) {
    }

    ngOnInit() {
        this.initUpload();
        if (this.type !== 'cms') {
            this.uploadConfig.resizeWidth = this.resizeWidth;
        }
    }

    initUpload() {
        this.uploadConfig = {
            url: this.env.imageUploadPath + 'cms/images/upload',
            acceptedFiles: 'image/*',
            parallelUploads: 1,
            resizeWidth: this.resizeWidth,
            maxFiles: 8,
            maxFilesize: 5120,
            params: {
                type: this.type,
                ownerId: this.ownerId
            },
            // The API's upload routes now require the admin session: send the cookie and
            // the app-name the API uses to pick auth.app.admin (Dropzone bypasses the interceptor).
            withCredentials: true,
            headers: {
                'api-key': '6bf9284a-ebf9-4afa-a185-4d2b9bb29e85',
                'app-name': 'admin'
            },
        };
    }
    onUploadError(e) {
    }

    onUploadSuccess(e) {
        this.initUpload();
        this.imageUploaded.emit(e[1]);
    }
    uploadprogress(e) {
    }
}
